export const DONE_THIS_WEEK_JQL = 'statusCategory = Done AND statusCategoryChangedDate >= -1w';
export const UPDATED_THIS_WEEK_JQL = 'updatedDate >= -1w';
export const CREATED_THIS_WEEK_JQL = 'createdDate >= -1w';
export const DUE_THIS_WEEK_JQL = 'statusCategory != Done AND (duedate >= 0d AND duedate < 1w)';
// Replicates the same query used in the board view when no filters are applied.
export const BOARD_ISSUES_JQL =
	'(statusCategory != Done OR (statusCategory = Done AND statusCategoryChangedDate >= -2w))';
export const OPEN_ISSUES_JQL = 'statusCategory != Done';

export const PAGED_DATA_PAGE_SIZE = 8;

export const ISSUES_BY_ASSIGNEE_FRAGMENT = `
  fragment IssuesByAssigneeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on UserField {
          userValue {
            accountId,
            avatarUrl,
            displayName
          }
        }
      }
      id,
      totalCount
    }
  }
`;

export const ISSUES_BY_TYPE_FRAGMENT = `
  fragment IssuesByTypeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on IssueTypeField {
              id
              name
              iconUrl
        }
      }
      id,
      totalCount
    }
  }
`;
